import OffersEmptyState from 'features/rewards/screens/MyOffers/components/OffersEmptyState/OffersEmptyState';
import SelfFundedOffersList from 'features/rewards/screens/MyOffers/components/SelfFundedOffersList/SelfFundedOffersList';
import UpsideOffersList from 'features/rewards/screens/MyOffers/components/UpsideOffersList/UpsideOffersList';
import { useMyOffersContext } from 'features/rewards/screens/MyOffers/providers/MyOffersProvider';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import theme from 'shared/styles/theme';

const ActiveOffersTab = () => {
  const { selfFundedItems, upsideOffers, isOverlayLoading, isPageLoading } =
    useMyOffersContext();
  const hasSelfFunded = selfFundedItems.length > 0;
  const hasUpside = upsideOffers.length > 0;
  const shouldShowUpsideEmptyState =
    !hasUpside && !isOverlayLoading && !isPageLoading;

  if (!hasSelfFunded && !hasUpside && !isOverlayLoading && !isPageLoading) {
    return <OffersEmptyState variant="activeOffers" />;
  }

  return (
    <>
      {hasSelfFunded ? (
        <>
          <SelfFundedOffersList />
          <View style={styles.sectionDivider} />
        </>
      ) : null}

      {hasUpside ? (
        <UpsideOffersList showSectionHeader={false} showFooterSubtitle />
      ) : null}

      {shouldShowUpsideEmptyState ? (
        <OffersEmptyState variant="activeOffers" />
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  sectionDivider: {
    height: 8,
    marginVertical: theme.spacing.s,
    backgroundColor: theme.color.background.tertiary,
  },
});

export default ActiveOffersTab;
